const BaLee = [
    {id: "0", value: "高檔背離"},    
    {id: "1", value: "低檔背離"},
  ];  
  
  export default BaLee